import React from "react";

export default class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { error: null };
  }
  static getDerivedStateFromError(error) {
    return { error };
  }
  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("App error caught:", error, info);
  }
  render() {
    if (this.state.error) {
      return (
        <div className="min-h-screen flex items-center justify-center p-10 text-center" data-testid="error-boundary">
          <div className="max-w-lg">
            <div className="label mb-3 !text-[var(--err)]">SYSTEM ERROR</div>
            <div className="font-display text-3xl font-bold mb-3">Something broke.</div>
            <p className="muted text-sm mb-6">An unexpected error occurred. Try reloading the page. If it persists, check the browser console for details.</p>
            <pre className="text-left font-mono text-[11px] bg-[var(--surface)] p-3 border border-[var(--line)] max-h-48 overflow-auto whitespace-pre-wrap">{String(this.state.error?.message || this.state.error)}</pre>
            <button className="btn-accent mt-6" onClick={() => window.location.reload()} data-testid="error-reload-btn">Reload</button>
          </div>
        </div>
      );
    }
    return this.props.children;
  }
}
